/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_nav_menu = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu`)
};

const zh_hans1_nav_menu = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`菜单`)
};

const zh_hant1_nav_menu = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選單`)
};

const fr_nav_menu = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu`)
};

const de_nav_menu = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menü`)
};

const ja_nav_menu = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メニュー`)
};

const ko_nav_menu = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`메뉴`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const nav_menu = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.nav_menu(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("nav_menu", locale)
	if (locale === "en") return en_nav_menu(inputs)
	if (locale === "zh-Hans") return zh_hans1_nav_menu(inputs)
	if (locale === "zh-Hant") return zh_hant1_nav_menu(inputs)
	if (locale === "fr") return fr_nav_menu(inputs)
	if (locale === "de") return de_nav_menu(inputs)
	if (locale === "ja") return ja_nav_menu(inputs)
	return ko_nav_menu(inputs)
};